import { memo } from 'react';
import ProductDiscountsBoxView from '../../../pricing/components/PriceDisplaying/Discounts/ProductDiscountsBoxView';
import type { ProductCustomerPrice } from '../../types';

const ProductDiscount = ({
    customerPrice,
    emptyValue = 'N/A',
}: {
    customerPrice?: ProductCustomerPrice;
    emptyValue?: string;
}) => {
    if (!customerPrice) {
        return <>{emptyValue}</>;
    }

    const dealerDiscountPercentage =
        customerPrice.dealerDiscountPercentage || 0;
    const additionalDiscountPercentage =
        customerPrice.additionalDiscountPercentage || 0;

    const { appliedDiscountRule } = customerPrice;

    const hasDiscounts =
        dealerDiscountPercentage > 0 ||
        additionalDiscountPercentage > 0 ||
        appliedDiscountRule;

    if (!hasDiscounts) {
        return <>{emptyValue}</>;
    }

    return <ProductDiscountsBoxView customerPrice={customerPrice} />;
};

export default memo(ProductDiscount);
